import { FALLBACK_LOCALE, SUPPORTED_LOCALES, type SupportedLocale } from '../../../i18n';
import type { ScreenshotId } from '../data/faqCatalog';
import { FAQ_SCREENSHOTS } from '../data/faqScreenshots';

// PARA-133 (AC-5) — чистая функция выбора кадра под текущую локаль. Без DOM,
// без React, без сети: тестируется в изоляции (resolveScreenshot.test.ts).

function isSupportedLocale(value: string): value is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

/**
 * Кадр статьи для текущего языка интерфейса.
 *
 * @param screenshotId — null у статьи, ответ которой самодостаточен текстом.
 * @param locale — i18n.language; может прийти вида 'en-US' или вовсе неизвестным,
 *   поэтому неподдерживаемое значение деградирует на FALLBACK_LOCALE — тем же
 *   способом, что и сам i18next (fallbackLng, AC-E3).
 */
export function resolveFaqScreenshot(
  screenshotId: ScreenshotId | null,
  locale: string,
): string | null {
  if (screenshotId === null) {
    return null;
  }
  const resolved = isSupportedLocale(locale) ? locale : FALLBACK_LOCALE;
  return FAQ_SCREENSHOTS[screenshotId][resolved];
}
